
// $(document).ready(function() {
//     $(document).on('click', '.product--atc', function(e) {
   
//         var variantId = $(this).attr('data-product-id');
//         var quantity = $('input[name="quantity"]').val(); // Quantity of the product
//         $.ajax({
//             url: "/cart/add.js",
//             method: "POST",
//             dataType: "JSON",
//             data: {
//                 id: variantId,
//                 quantity: quantity
//             },
//             success: function(data) {
//              window.location = "/checkout";    
//             }
//         });
//     });
// });


// document.addEventListener('DOMContentLoaded', function() {
//     document.body.addEventListener('click', function(e) {
//         if (e.target && e.target.matches('.product--atc')) {
//             var checkOutChampId = e.target.getAttribute('data-checkoutchamp-id');
//             var variantId = e.target.getAttribute('data-product-id');
//             var quantity = document.querySelector('input[name="quantity"]').value; // Quantity of the product
            
//             var formData = new FormData();
//             formData.append('id', variantId);
//             formData.append('quantity', quantity);

//             fetch('/cart/add.js', {
//                 method: 'POST',
//                 body: formData,
//             })
//             .then(response => response.json())
//             .then(data => {
//                 if (checkOutChampId) {
//                     location.href = `https://checkout.mein-pacha.de/checkout?products=${checkOutChampId}:1`;
//                 } else {
//                     location.href = `/checkout`;
//                 }
//                 re
//             })
//             .catch(error => console.error('Error adding to cart:', error));
//         }
//     });
// });

document.addEventListener('DOMContentLoaded', function() {
    document.body.addEventListener('click', function(e) {
        if (e.target && e.target.matches('.product--atc')) {
            var checkOutChampId = e.target.getAttribute('data-checkoutchamp-id');
            var variantId = e.target.getAttribute('data-product-id');
            var quantity = document.querySelector('input[name="quantity"]').value;

            // First clear the cart
            fetch('/cart/clear.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(() => {
                // After clearing, add the product
                var formData = new FormData();
                formData.append('id', variantId);
                formData.append('quantity', quantity);

                return fetch('/cart/add.js', {
                    method: 'POST',
                    body: formData
                });
            })
            .then(response => response.json())
            .then(data => {
                if (checkOutChampId) {
                    location.href = `https://checkout.mein-pacha.de/checkout?products=${checkOutChampId}:1`;
                } else {
                    location.href = `/checkout`;
                }
            })
            .catch(error => {
                console.error('Error processing cart:', error);
                window.alert('There was an error updating your cart. Please try again.');
            });
        }
    });
});

